import { useCallback, useMemo } from "react"

import { deliverFormConfig as horizontalSigningFormConfig, API_MODULE_HORIZONTAL_SIGNING } from "@l2r-front/l2r-app-city"
import { useTranslation } from "@l2r-front/l2r-i18n"
import { Campaign } from "@l2r-front/l2r-proptypes"
import { I18N_NAMESPACE } from "@l2r-front/l2r-shared-campaign"

import { useCampaignDeliver } from "../../hooks/mutations/useCampaignDeliver"
import { useModuleProjectTags } from "../../hooks/useModuleProjectTags"

import { CampaignDeliverForm } from "./CampaignDeliverForm"

export interface CampaignDeliverFormPostProps {
    campaign: Campaign
    onClose: (_checkModifications?: boolean) => void
    onChange: (hasChanges: boolean) => void
    onSubmitting: (_submitting: boolean) => void
}

export const CampaignDeliverFormPost = (props: CampaignDeliverFormPostProps) => {

    const {
        campaign,
        onClose,
        onChange,
        onSubmitting,
    } = props

    const { t } = useTranslation(I18N_NAMESPACE)

    const campaignMutation = useCampaignDeliver(campaign.uuid, {}, {
        errorSnackbarMessage: t(I18N_NAMESPACE, "forms.campaignDeliverForm.snackbar.error"),
        successSnackbarMessage: t(I18N_NAMESPACE, "forms.campaignDeliverForm.snackbar.success"),
        onSuccess: () => {
            onSubmitting(false)
            onClose(false)
        },
        onError: () => {
            onSubmitting(false)
        },
    })

    const formConfiguration = useMemo(() => {
        switch (campaign.campaign_type) {
            case API_MODULE_HORIZONTAL_SIGNING:
                return horizontalSigningFormConfig
        }
    }, [campaign.campaign_type])

    const projectTags = useModuleProjectTags(campaign.campaign_type)

    const onSubmit = useCallback((formValues) => {
        campaignMutation.mutate(formValues)
        onSubmitting(true)
    }, [campaignMutation, onSubmitting])

    return <CampaignDeliverForm
        formConfiguration={formConfiguration}
        projectTags={projectTags}
        isSubmitting={campaignMutation.isPending}
        onSubmit={onSubmit}
        onChange={onChange}
        onCancel={() => onClose()}
    />
}
